import React, { Component } from "react";
import PopupRecuperar from "./PopupRecuperar";
/**
 * 
 */
export default class ButtonRecuperar extends Component {
    constructor(props) {
        super(props);
    }
    /**
     * Actualiza el estado de la novedad a cancelada
     * @param {any} novedad
     */
    recuperarTarjeta(novedad) {
        const { actualizarNovedadEstado, entidadTipo, tarjeta } = this.props;
        return actualizarNovedadEstado(novedad.Id, 7, novedad.NovedadCampoCodigo, entidadTipo, tarjeta.CuentaTarjetaId)
    }
    /**
     * Crea una nueva novedad en estado recuperada
     */
    crearNovedad() {
        const { codigoNovedad, guardarNovedadBloqueo, tarjeta } = this.props;

        let novedad = {
            Id: null,
            NovedadCampoCodigo: codigoNovedad,
            ValorAnterior: null,
            ValorNovedad: tarjeta.TarjetaBloqueoMotivoId,
            TarjetaCreditoId: tarjeta.TarjetaCreditoId,
            CuentaTarjetaId: tarjeta.CuentaTarjetaId,
            EstadoId: 1
        }

        return guardarNovedadBloqueo(novedad);
    }
    /**
     * 
     */
    render() {
        const { actualizarNovedadEstado, entidadTipo, funcionesDelUsuario, novedad, tarjeta } = this.props;
        let componente = null;

        /*Si hay novedad de baja se puede recuperar*/
        if (novedad.novedadBaja) {
            let motivoDescripcion = "Motivo: " + novedad.motivoDescripcion;

            if (novedad.novedadBaja.NovedadEstadoId == 4) {
                motivoDescripcion = "";
            }
            componente = (
                <PopupRecuperar clave={"popup-recuperar-" + tarjeta.TarjetaCreditoId}
                    esBloqueo={false}
                    funcionesDelUsuario={funcionesDelUsuario}
                    motivoDescripcion={motivoDescripcion}
                    novedad={novedad.novedadBaja}
                    textBoton="DADA BAJA"
                    mostrarTitle={false}

                    confirmarNovedad={() => actualizarNovedadEstado(novedad.novedadBaja.Id, 2, novedad.novedadBaja.NovedadCampoCodigo, entidadTipo, tarjeta.CuentaTarjetaId)}
                    denegarNovedad={() => actualizarNovedadEstado(novedad.novedadBaja.Id, 3, novedad.novedadBaja.NovedadCampoCodigo, entidadTipo, tarjeta.CuentaTarjetaId)}
                    recuperarTarjeta={() => this.recuperarTarjeta(novedad.novedadBaja)} />
            );
        } else {
            /*si fue aprobada por la administradora y el usuario la recuperó*/
            if (novedad.novedadRecuperada) {
                componente = (
                    <div className="popup-tarjetas-bloqueo" title={novedad.motivoDescripcion}>
                        <div className="container-estado novedad">
                            <label >{/*tarjeta.TarjetaCreditoEstado*/}RECUPERADA</label>
                        </div>
                    </div>
                );
            } else {
                /*si fue aprobada por la administradora entonces ya no es posible realizar ninguna accion*/
                if (novedad.validacionBaja) {
                    componente = (
                        <div className="popup-tarjetas-bloqueo" title={novedad.motivoDescripcion}>
                            <div className="container-estado sin-novedad">
                                <label >{/*tarjeta.TarjetaCreditoEstado*/}DADA BAJA</label>
                            </div>
                        </div>
                    );
                } else {
                    /*si fue aprobada por la administradora entonces puede volver a generar un novedad para recuperarla DEPRECADA v0 */
                    if (novedad.validacionBloqueo) {
                        /*si fue aprobada por la administradora ya no es posible recuperarla v1*/
                        componente = (
                            <div className="popup-tarjetas-bloqueo" title={novedad.motivoDescripcion}>
                                <div className="container-estado sin-novedad">
                                    <label>BLOQUEADA</label>
                                </div>
                            </div>
                        );
                    } else {
                        /*componente normal, solamente descripcion*/
                        componente = (
                            <div>
                                <div className="modal-news-modifications-button-lightgreen-central-rectangle">
                                    <label className="label-tipografy-estados">{tarjeta.TarjetaCreditoEstado.toString().toUpperCase()}</label>
                                </div>
                            </div>
                        );
                    }
                }
            }
        }

        return (
            <td className="default-td">
                {componente}
            </td>
        );
    }
}